"use client";

import * as React from "react";

export interface PageBannerProps {
  children: React.ReactNode;
}

/** Inline banners only — portaled modals belong in `overlays`, not `beforeContent`. */
export function PageBanner({ children }: PageBannerProps) {
  return <div className="contents">{children}</div>;
}
